const identity = (t) => t

export function createAction (type, payloadCreator, metaCreator) {
  const finalPayloadCreator = typeof payloadCreator === 'function'
    ? payloadCreator
    : payloadCreator && payloadCreator.noPayload
      ? null
      : identity

  const actionCreator = (...args) => {
    const hasError = args[0] instanceof Error

    const action = {
      type
    }

    let payload = null
    if (finalPayloadCreator !== null) {
      payload = hasError ? args[0] : finalPayloadCreator(...args)
    }
    if (!(payload === null || payload === undefined)) {
      action.payload = payload
    }

    if (hasError || payload instanceof Error) {
      // Handle FSA errors where the payload is an Error object. Set error.
      action.error = true
    }

    if (typeof metaCreator === 'function') {
      action.meta = metaCreator(...args)
    }

    return action
  }

  actionCreator.toString = () => type.toString()
  actionCreator.type = type.toString()

  return actionCreator
}

export function action (type, payload) {
  return { type, payload }
}

export function asyncAction (config) {
  let event = {
    name: config.baseName,
    start: config.baseName + '_START',
    success: config.baseName + '_SUCCESS',
    error: config.baseName + '_ERROR'
  }

  let request = (type, isPending, error) => (payload) => ({
    type,
    payload,
    request: {
      id: config.baseName,
      isPending,
      error: error ? payload : null
    }
  })

  let dispatchers = {
    start: request(event.start, true),
    success: request(event.success, false),
    error: request(event.error, false, true)
  }

  let action = config.action(dispatchers)

  action.event = event

  return action
}

export const createPollingAction = (action, frequency) => {
  let actionInterval = null
  let stop = () => {
    if (actionInterval) clearInterval(actionInterval)
  }
  let start = (dispatch, getState) => {
    stop()
    action(dispatch, getState)
    // actionInterval = setInterval(() => action(dispatch, getState), frequency)
  }

  return { start, stop }
}



// WEBPACK FOOTER //
// ./client/src/util/actions.js